import moment from 'moment';

export function getTimeAgoClass(time){
  let timeAgo = moment(time).diff(Date.now(), 'days')
  if(-timeAgo > 20) return 'time-chip red'
  else if(-timeAgo > 10) return 'time-chip orange'
  else return 'time-chip green'
}
